import React from 'react';
import Header from '../components/Header';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { getDeputyTitleFromRouteId } from '../utils/deputy';
import { getBackgroundImage } from '../utils/organization';

export default function HomePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const navItems = [
    {
      title1: t('structure'),
      route: `/organization/${id}`,
    },
    {
      title1: currentLanguage === 'en' ? t('achievement') : t('attainment'),
      title2: currentLanguage === 'id' && t('achievement'),
      route: `/achievement/${id}`,
    },
    {
      title1: t('documentation'),
      title2: t('fromTimeToTime'),
      route: `/gallery/${id}`,
    },
  ];

  const bgImage = getBackgroundImage(id);

  return (
    <div
      className="min-h-screen bg-darkBlue flex text-white bg-cover bg-no-repeat pt-60 pb-40 pl-60 pr-80"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.6) 100%), url(${bgImage})`,
      }}
    >
      <div className="w-full">
        <Header />
        <div className="flex flex-col mt-36 space-y-18 w-full relative">
          {navItems.map((nav, idx) => (
            <div
              className="p-30 w-full flex space-x-32 items-center cursor-pointer bg-[rgba(0,45,75,0.70)] hover:bg-darkerBlue"
              onClick={() => navigate(nav.route)}
            >
              <div className="text-[70px] text-white text-opacity-50 font-bold min-w-[95px]">
                0{idx + 1}
              </div>
              <div>
                <div className="text-title text-blue font-bold uppercase">
                  {nav.title1}
                </div>
                {nav.title2 && (
                  <div className="text-title text-white font-bold uppercase">
                    {nav.title2}
                  </div>
                )}
              </div>
              <div className="pl-16">
                <ArrowCircleRightIcon sx={{ fontSize: 60 }} />
              </div>
            </div>
          ))}

          <div
            className="absolute right-0 top-[100px] w-[575px] h-[325px] bg-cover bg-no-repeat"
            style={{
              backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.6) 100%), url(${bgImage})`,
            }}
          >
            <div className="absolute right-30 bottom-28 text-title text-white uppercase font-bold w-3/4 text-right">
              {getDeputyTitleFromRouteId(id, t)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
